/**
 * Next-day delivery cutoff: live countdown + UK Mainland postcode check.
 * Postcode result cached in localStorage for 14 days.
 */
(function () {
  var STORAGE_KEY = 'tt_delivery_postcode_v1';
  var DEFAULT_TTL_DAYS = 14;

  function formatMinutesRemaining(totalMinutes) {
    if (totalMinutes <= 0) return null;

    var hours = Math.floor(totalMinutes / 60);
    var minutes = totalMinutes % 60;

    if (hours > 0 && minutes > 0) {
      return (
        hours +
        (hours === 1 ? ' hour ' : ' hours ') +
        minutes +
        (minutes === 1 ? ' minute' : ' minutes')
      );
    }

    if (hours > 0) {
      return hours + (hours === 1 ? ' hour' : ' hours');
    }

    return minutes + (minutes === 1 ? ' minute' : ' minutes');
  }

  function normalizePostcode(value) {
    return String(value || '')
      .toUpperCase()
      .replace(/[^A-Z0-9]/g, '');
  }

  function isFullPostcode(normalized) {
    return /^[A-Z]{1,2}\d[A-Z\d]?\d[A-Z]{2}$/i.test(normalized);
  }

  function isOutwardCode(normalized) {
    return /^[A-Z]{1,2}\d[A-Z\d]?$/i.test(normalized);
  }

  function getOutwardCode(normalized) {
    if (!normalized) return '';
    // Inward code is always the final digit + 2 letters. Only strip it from a full postcode
    // so a 4-character outward code such as PL13 is not shortened to P.
    if (isFullPostcode(normalized)) {
      return normalized.slice(0, normalized.length - 3);
    }
    return normalized;
  }

  function parseJsonScript(root, selector) {
    var el = root.querySelector(selector);
    if (!el) return null;
    try {
      return JSON.parse(el.textContent.trim() || 'null');
    } catch (e) {
      return null;
    }
  }

  function pushPrefixes(target, list) {
    if (!Array.isArray(list)) return;
    list.forEach(function (prefix) {
      var cleaned = String(prefix || '')
        .toUpperCase()
        .replace(/\s+/g, '')
        .trim();
      if (cleaned) target.push(cleaned);
    });
  }

  function collectExcludedPrefixes(root) {
    var prefixes = [];
    var config = parseJsonScript(root, '[data-delivery-shipping-config]');
    var builtIn = parseJsonScript(root, '[data-delivery-excluded-prefixes]');
    var extra = parseJsonScript(root, '[data-delivery-extra-prefixes]');

    if (config && Array.isArray(config.regions)) {
      config.regions.forEach(function (region) {
        if (!region || !Array.isArray(region.postcodePrefixes)) return;
        // Listed regions are exclusions from default mainland
        pushPrefixes(prefixes, region.postcodePrefixes);
      });
    }

    // Built-in FAQ/metafield snapshot + optional theme setting extras
    pushPrefixes(prefixes, builtIn);
    pushPrefixes(prefixes, extra);

    // Longest-first so AB10 matches before AB1-style collisions
    return prefixes
      .filter(function (value, index, self) {
        return value && self.indexOf(value) === index;
      })
      .sort(function (a, b) {
        return b.length - a.length;
      });
  }

  function isMainlandPostcode(postcode, excludedPrefixes) {
    var normalized = normalizePostcode(postcode);
    if (!normalized) return false;

    // Basic UK postcode shape (allows outward-only while typing completes)
    if (!isFullPostcode(normalized) && !isOutwardCode(normalized)) {
      return null; // invalid
    }

    // Match the outward code only. The inward digit must not be glued on,
    // or PL1 3AA (PL13AA) is treated as excluded prefix PL13.
    var outward = getOutwardCode(normalized);
    for (var i = 0; i < excludedPrefixes.length; i++) {
      var prefix = excludedPrefixes[i];
      if (outward.indexOf(prefix) === 0) {
        return false;
      }
    }

    return true;
  }

  function readStorage(ttlDays) {
    try {
      var raw = window.localStorage.getItem(STORAGE_KEY);
      if (!raw) return null;
      var data = JSON.parse(raw);
      if (!data || !data.checkedAt) return null;
      var ttlMs = (ttlDays || DEFAULT_TTL_DAYS) * 24 * 60 * 60 * 1000;
      if (Date.now() - data.checkedAt > ttlMs) {
        window.localStorage.removeItem(STORAGE_KEY);
        return null;
      }
      return data;
    } catch (e) {
      return null;
    }
  }

  function writeStorage(payload) {
    try {
      window.localStorage.setItem(
        STORAGE_KEY,
        JSON.stringify(
          Object.assign({}, payload, {
            checkedAt: Date.now(),
          })
        )
      );
    } catch (e) {
      // ignore quota / private mode
    }
  }

  function initCountdown(el) {
    if (!el || el.dataset.deliveryCutoffInitialized === 'true') return;

    var minutesRemaining = parseInt(el.getAttribute('data-minutes-remaining'), 10);
    var timeEl = el.querySelector('[data-delivery-cutoff-time]');
    if (!timeEl || isNaN(minutesRemaining)) return;

    el.dataset.deliveryCutoffInitialized = 'true';

    function render() {
      if (minutesRemaining <= 0) {
        var root = el.closest('[data-delivery-cutoff-root]');
        if (root) root.remove();
        else el.remove();
        return;
      }

      var formatted = formatMinutesRemaining(minutesRemaining);
      if (formatted) timeEl.textContent = formatted;
    }

    render();
    window.setInterval(function () {
      minutesRemaining -= 1;
      render();
    }, 60000);
  }

  function formatDisplayPostcode(value) {
    var normalized = normalizePostcode(value);
    if (normalized.length > 3) {
      return normalized.slice(0, -3) + ' ' + normalized.slice(-3);
    }
    return normalized;
  }

  function fillPostcodeTemplate(template, postcode) {
    var display = formatDisplayPostcode(postcode);
    return String(template || '')
      .split('[postcode]')
      .join(display)
      .split('{{postcode}}')
      .join(display);
  }

  function setStatus(root, status) {
    var card = root.querySelector('[data-delivery-cutoff-card]');
    var input = root.querySelector('[data-delivery-postcode-input]');
    if (card) card.setAttribute('data-status', status);
    if (input) {
      if (status === 'error') input.setAttribute('aria-invalid', 'true');
      else input.removeAttribute('aria-invalid');
    }
  }

  function setMessage(root, text) {
    var messageEl = root.querySelector('[data-delivery-postcode-message]');
    if (!messageEl) return;
    var hint = root.getAttribute('data-postcode-hint') || '';
    messageEl.textContent = text || hint;
  }

  function applyMainlandState(root, data) {
    var input = root.querySelector('[data-delivery-postcode-input]');
    var unavailableTemplate = root.getAttribute('data-unavailable-template') || '';
    var availableTemplate = root.getAttribute('data-available-template') || '';

    if (data && data.mainland === true) {
      setStatus(root, 'success');
      if (input && data.postcode) input.value = formatDisplayPostcode(data.postcode);
      setMessage(root, fillPostcodeTemplate(availableTemplate, data.postcode));
      return;
    }

    if (data && data.mainland === false) {
      setStatus(root, 'error');
      if (input && data.postcode) input.value = formatDisplayPostcode(data.postcode);
      setMessage(root, fillPostcodeTemplate(unavailableTemplate, data.postcode));
      return;
    }

    setStatus(root, 'idle');
    setMessage(root, '');
  }

  function initPostcodeCheck(root) {
    if (root.dataset.postcodeInitialized === 'true') return;
    if (root.getAttribute('data-postcode-check') !== 'true') {
      setStatus(root, 'idle');
      return;
    }

    root.dataset.postcodeInitialized = 'true';

    var ttlDays = parseInt(root.getAttribute('data-storage-ttl-days'), 10) || DEFAULT_TTL_DAYS;
    var excludedPrefixes = collectExcludedPrefixes(root);
    var submitBtn = root.querySelector('[data-delivery-postcode-submit]');
    var input = root.querySelector('[data-delivery-postcode-input]');
    var customerPostcode = root.getAttribute('data-customer-postcode') || '';
    var stored = readStorage(ttlDays);

    // Prefer customer address when it differs from stale storage
    if (customerPostcode && (!stored || normalizePostcode(stored.postcode) !== normalizePostcode(customerPostcode))) {
      var customerMainland = isMainlandPostcode(customerPostcode, excludedPrefixes);
      if (customerMainland !== null) {
        stored = {
          postcode: customerPostcode.toUpperCase().trim(),
          outward: getOutwardCode(normalizePostcode(customerPostcode)),
          mainland: customerMainland,
        };
        writeStorage(stored);
      }
    }

    if (input && stored && stored.postcode) {
      input.value = stored.postcode;
    } else if (input && customerPostcode) {
      input.value = customerPostcode;
    }

    applyMainlandState(root, stored);

    function checkPostcode(event) {
      if (event) event.preventDefault();
      var value = input ? input.value : '';
      var mainland = isMainlandPostcode(value, excludedPrefixes);

      if (mainland === null) {
        setStatus(root, 'error');
        setMessage(root, 'Please enter a valid UK postcode');
        return;
      }

      var payload = {
        postcode: formatDisplayPostcode(value),
        outward: getOutwardCode(normalizePostcode(value)),
        mainland: mainland,
      };
      writeStorage(payload);
      applyMainlandState(root, payload);
    }

    if (submitBtn) {
      submitBtn.addEventListener('click', checkPostcode);
    }

    if (input) {
      input.addEventListener('keydown', function (event) {
        if (event.key === 'Enter') {
          event.preventDefault();
          checkPostcode(event);
        }
      });
    }
  }

  function initRoot(root) {
    if (!root) return;
    initPostcodeCheck(root);
    var banner = root.querySelector('[data-delivery-cutoff]');
    if (banner) initCountdown(banner);
  }

  function initAll() {
    document.querySelectorAll('[data-delivery-cutoff-root]').forEach(initRoot);
    // Legacy: countdown-only nodes without root wrapper
    document.querySelectorAll('[data-delivery-cutoff]').forEach(function (el) {
      if (!el.closest('[data-delivery-cutoff-root]')) initCountdown(el);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('cart:updated', initAll);
  document.addEventListener('shopify:section:load', initAll);
})();
